export default class TelFortuneApplication {
    id: number;
    chatRoomId?: number;
    name?: string;

    constructor(data?: Partial<TelFortuneApplication>) {
        Object.assign(this, data);
    }
}
